import { List as ListBase } from './List';
import { Item, SimpleItem } from './Item';
import { Label } from './Label';
import { Description } from './Description';
import { CheckTrail } from './CheckTrail';
import { RadioTrail } from './RadioTrail';
import { Item as CollectionItem } from '@react-stately/collections';
export const List = Object.assign(ListBase, {
    /**
     * Обязан быть прямым чилдреном у List, без этого коллекции react-aria не работают
     */
    CollectionItem,
    /**
     * Обязан быть обернут в List.CollectionItem
     */
    Item,
    /**
     * Обязан быть обернут в List.CollectionItem
     */
    SimpleItem,
    /**
     * Обязан быть обернут в List.Item
     */
    Label,
    /**
     * Обязан быть обернут в List.Item
     */
    Description,
    /**
     * Обязан быть обернут в List.Item
     */
    CheckTrail,
    /**
     * Обязан быть обернут в List.Item
     */
    RadioTrail,
});
